var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Soundcloud = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.playhead / 1000
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.duration / 1000
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return false
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Soundcloud"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references[SC.Widget.Events.PLAY] = this.playListener.bind(this)
    this.references[SC.Widget.Events.PLAY_PROGRESS] = this.playProgressListener.bind(this)
    this.references[SC.Widget.Events.PAUSE] = this.pauseListener.bind(this)
    this.references[SC.Widget.Events.FINISH] = this.finishListener.bind(this)
    this.references[SC.Widget.Events.SEEK] = this.seekListener.bind(this)
    this.references[SC.Widget.Events.ERROR] = this.errorListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.bind(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.unbind(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'PLAY' event. */
  playListener: function (e) {
    this.playhead = e.currentPosition
    this.progress = e.loadedProgress
    if (this.progress > 0) {
      this.fireStart()
      this.fireResume()
      this.fireSeekEnd()
      this.fireBufferEnd()
      this.fireJoin()
    }
  },

  /** Listener for 'PLAY_PROGRESS' event. */
  playProgressListener: function (e) {
    this.playhead = e.currentPosition
  },

  /** Listener for 'PAUSE' event. */
  pauseListener: function (e) {
    this.playhead = e.currentPosition
    this.firePause()
  },

  /** Listener for 'ERROR' event. */
  errorListener: function (e) {
    this.playhead = e.currentPosition
    this.fireError()
  },

  /** Listener for 'SEEK' event. */
  seekListener: function (e) {
    this.progress = e.loadedProgress
    this.fireSeekBegin()
    this.fireSeekEnd()
  },


  /** Listener for 'FINISH' event. */
  finishListener: function (e) {
    this.playhead = e.currentPosition
    this.fireStop()
  }
})

module.exports = youbora.adapters.Soundcloud



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0